// Generated by scripts/build-ui-icons.mjs.
export { PencilSimple as default } from "../ui/glyphs-6";
